import { JSX } from "react";

import { MenuItem, Select, type Theme, type SelectChangeEvent } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import FrameTypeLastDays from "src/constants/frameTypeLastDays.enum";

function Dropdown({ value, onChange }: { value: number; onChange: (event: SelectChangeEvent) => void }): JSX.Element {
  const { t } = useTranslation();
  const frameTypeNames = Object.values(FrameTypeLastDays).filter((value) => typeof value === "string");
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Select size='medium' value={value.toString()} onChange={onChange}>
      {frameTypeNames.map((listItem, index) => (
        <MenuItem key={listItem} value={index} disabled={isMobile && index === FrameTypeLastDays.LastThirtyDays}>
          {t(listItem.toString().toLowerCase())}
        </MenuItem>
      ))}
    </Select>
  );
}

export default Dropdown;
